const TextAreaField = ({  
    id, 
    label, 
    value, 
    onChange, 
    disabled = false, 
    required = false,
    rows = 3  ,
    formSubmitted
}) => (

  
    <div className="flex flex-col">
      
      <label htmlFor={id}>{label}:</label>
      <textarea
        disabled={disabled}
        className="border-[2px] px-4 py-2"
        id={id}
        name={id}
        value={value}
        onChange={onChange}
        required={required}
        rows={rows}
      />
      
    </div>
    );
export default TextAreaField;
